import type {App} from 'vue';
import type {AppAxiosRequestConfig} from '@/helpers/api';
import {auth} from '@/api/auth';

export default {
    install(app: App, options: AppAxiosRequestConfig) {

        auth.defaults.baseURL = options.baseURL;

        if (options.params) {

            auth.defaults.params = options.params;
        }

        app.provide("$auth", auth);
        app.config.globalProperties.$auth = auth;
    }
}